module.exports = __webpack_public_path__ + "9ddf711b100626fc152b790654728be8.png";